import React from 'react';

export default {
  returnButtonLabel: 'Voltar',
  continueButtonLabel: 'Continuar',
  redemptDomain: 'Resgatar domínio',
  continueButton: 'Continuar',
  banner: {},
  inputDomainStep: {
    title: 'Qual será o endereço do seu site?',
    description: 'Digite o nome do domínio desejado e escolha entre as extensões disponíveis para resgatar seu domínio gratuito.',
    tooltipLabel: 'Após um ano, a renovação do domínio terá um custo.',
    searchTld: 'Buscar extensão',
    freeTag: 'Grátis',
    otherOptionsLabel: 'Veja algumas alternativas para você:',
    myDataButtonLabel: 'Meus dados',
    featuredLabel: 'Destaque',
    radixUnavailable: (domain, radixDomain) => (
      <>
        {'O domínio '}
        <strong>{`"${radixDomain}"`}</strong>
        {' já tem dono. Ao clicar em "Continuar", você irá registrar apenas o '}
        <strong>{`"${domain}"`}</strong>
      </>
    ),
    invalidDocumentDescription: (
      <>
        <strong>
          {'Para continuar, acesse a página Meus Dados e atualize suas informações. '}
        </strong>
        Depois, retorne para este fluxo para concluir sua compra.
      </>
    ),
    inputErrors: {
      invalidDomain: 'Domínio inválido',
      startOrEndWithHyphen: 'O domínio não pode começar ou terminar com hífen',
      twoHyphensInARow: 'O domínio não pode ter dois hífens seguidos',
      lessThanThreeCharacters: 'Use 3 caracteres ou mais para seu domínio',
      hasSpecialChars: 'O domínio não pode ter caracteres especiais, com exceção do hífen',
      domainIsUnavailable: 'Parece que esse domínio já tem dono. Experimente outro nome ou escolha uma das opções disponíveis!',
      unavailableWithoutChoose: 'Domínio indisponível. Experimente outro nome ou escolha uma das opções disponíveis!',
      documentIsInvalid: 'Seu documento não atende aos requisitos para a compra ou indica que você é menor de 18 anos.',
    },
  },
  freeDomainStep: {
    title: plan => ({
      335: 'Você ganhou mais <span>2 domínios grátis</span> por 1 ano',
      6: 'Você ganhou mais <span>1 domínio grátis</span> por 1 ano',
    })[plan],
    description: plan => ({
      335: 'Com o Plano Turbo, você ganha <strong>2 domínios adicionais grátis</strong> por 1 ano. Registre agora seu domínio <span>.online</span> e o <span>.store</span>*',
      6: 'Com o Plano M, você ganha <strong>1 domínio adicional grátis</strong> por 1 ano. Registre agora seu domínio <span>.online</span>*',
    })[plan],
    firstFreeDomain: 'Seu primeiro domínio gratuito (<span>.online</span>)',
    secondFreeDomain: 'Seu segundo domínio gratuito (<span>.store</span>)',
    activeRadix: {
      title: 'Ativar domínio gratuito',
      about: 'Seu domínio será registrado sem custo. Após um ano, será necessário renová-lo mediante pagamento.',
    },
    refuseRadix: 'Seguir sem ativar o domínio gratuito. Caso opte por não ativar, você perderá o direito a esse domínio gratuito.',
    disclaimer: '*Seu domínio será registrado sem custo. Após um ano, será necessário renová-lo mediante pagamento.',
    freeTag: 'Grátis',
    radixUnavailable: {
      online: radixDomain => (
        <>
          {'O domínio '}
          <strong>{`"${radixDomain}"`}</strong>
          {' já está registrado. Verifique a disponibilidade de registro nas opções .site ou .store'}
        </>
      ),
      store: radixDomain => (
        <>
          {'O domínio '}
          <strong>{`"${radixDomain}"`}</strong>
          {' já está registrado. Verifique a disponibilidade de registro nas opções .site ou .online'}
        </>
      ),
    },
  },
  successStep: {
    content: ({ domains }) => {
      const content = {
        1: {
          description: `Seu domínio "${domains[0]}" foi resgatado com sucesso!`,
          infoList: ['Agora ele está disponível para uso na sua conta'],
          renewalNotice: 'Após um ano, a renovação do domínio terá um custo.',
        },
        2: {
          description: `Os domínios "${domains[0]}" e "${domains[1]}" foram resgatados com sucesso!`,
          infoList: ['Agora eles estão disponíveis para uso na sua conta'],
          renewalNotice: 'Após um ano, a renovação dos domínios terá um custo.',
        },
        3: {
          description: `Os domínios "${domains[0]}", "${domains[1]}" e "${domains[2]}" foram resgatados com sucesso!`,
          infoList: ['Agora eles estão disponíveis para uso na sua conta'],
          renewalNotice: 'Após um ano, a renovação dos domínios terá um custo.',
        },
      };

      return ({
        title: 'Ótima escolha!',
        ...content[domains.length],
      });
    },
  },
  errors: {
    unexpectedErrorTitle: 'Ocorreu um erro inesperado',
    unexpectedErrorInfo: 'Tente novamente mais tarde',
  },
};
